<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row col-md-12">
            <div class="d-flex justify-content-start col-md-2" v-if="listaTerceros.length != 0">
                <b-input-group class="mb-3" size="sm">
                    <b-form-input
                        v-model="filtroNombre"
                        placeholder="Buscar por nombre"
                        debounce="100"
                        class="form-control"
                    ></b-form-input>
                </b-input-group>
            </div>
            <div class="d-flex justify-content-end col-md-10">
                <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createTercero()">
                    <md-icon>add</md-icon>
                </md-button>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="listaTerceros.length != 0">
            <b-table
                :items="listaTerceros"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :total-rows="filteredRows"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filtroNombre"
                :filter-function="filtrarPorNombre"
                @row-clicked="(item) => editTercero(item.id)"
            >
            </b-table>
            <div class="row col-md-12 justify-content-center mt-3" v-if="listaTerceros != 0">
                <div class="row col-12 mt-1">
                    <div class="col-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="listaTerceros.length"
                        :per-page="perPage"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modalCrear="showModTercero" @cierraModal="closeModal"/>
        <Editar :modalEditar="showModEditTercero" :infoTercero="dataTercero" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>

import Tercero from '../../services/Tercero'
import Crear from './Crear.vue';
import Editar from './Editar.vue';

export default {
    name:'Tercero',
    components:{
        Crear,
        Editar
    },
    data:() => ({
        listaTerceros : [],
        dataTercero : [],
        showModTercero : false,
        showModEditTercero : false,
        perPage: 500,
        currentPage: 1,
        fields: [
            {key: 'identificacion', label: 'Nit', sortable: false},
            {key: 'digito_verificacion', label: 'Digito verificacion', sortable: false},
            {key: 'nombre', label: 'Nombre', sortable: false},
            {key: 'telefono', label: 'Telefono', sortable: false},
            {key: 'correo', label: 'Correo', sortable: false},
        ],
        filtroNombre : ''
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){

                return {
                    title : 'Tercero',
                    noRow : 'No hay registros',
                    code : 'Código',
                    identification : 'Identificación',
                    digitoVeri : 'Digito verificación',
                    nombre : 'Nombre',
                    telefono : 'Telefono',
                    correo : 'Correo',
                }

            }else{

                return {
                    title : 'Third',
                    noRow : 'There are not records',
                    code : 'Code',
                    identification : 'ID',
                    digitoVeri : 'Verification digit',
                    nombre : 'Name',
                    telefono : 'Phone',
                    correo : 'Email',
                }

            }
        },
        filteredRows() {
            // Devuelve cuántos registros hay luego de aplicar el filtro
            return this.listaTerceros.filter(item =>
                item.nombre.toString().includes(this.filtroContrato)
            ).length
        }
    },
    methods:{
        createTercero(){
            this.showModTercero = true
        },
        editTercero(id){

            Tercero.getTerceroById(id)
            .then((res) => {
                // console.log(res.data.tercero);
                this.dataTercero = res.data.tercero
                this.showModEditTercero = true
            })
            .catch((err) => { console.log(err)})            
        },
        closeModal(val){
            this.showModTercero = val
            this.showModEditTercero = val
        },
        filtrarPorNombre(item, filtro) {
            if (!filtro) return true
            const texto = filtro.toString().toLowerCase()
            return item.nombre.toString().toLowerCase().includes(texto)
        },
    },
    mounted(){
        Tercero.getAllTercero()
        .then((res) => {
            // console.log(res.data.listTercero);
            this.listaTerceros = res.data.listTercero
        })
        .catch((err) => { console.log(err)})
    }
}
</script>

<style>

</style>